import styled from 'styled-components'
import { Box, Flex } from 'vvs-uikit'

export const MoleBaseCardWrapper = styled(Flex)<{ disabled?: boolean }>`
  ${({ disabled }) =>
    !disabled &&
    `
    cursor: pointer;
  `}
  flex-direction: column;
  border: 3px solid black;
  border-radius: 4px;
  filter: drop-shadow(4px 6px 0px rgba(0, 0, 0, 0.25));
`

export const MoleCardWrapper = styled(MoleBaseCardWrapper)`
  width: 126px;
  margin-top: 6px;
`

export const CardRow = styled(Flex)`
  &:not(:last-child) {
    border-bottom: 3px solid black;
  }
`
export const CardLabel = styled(CardRow)`
  ${({ background, theme }) =>
    !background &&
    `
    background: ${theme.colors.primaryLight};
  `}
  justify-content: space-between;
  align-items: center;
`

export const MoleMiniCardWrapper = styled(MoleBaseCardWrapper)`
  overflow: hidden;
  width: 56px;
`

export const MoleMiniCardShadow = styled(Box)`
  width: 56px;
  height: 91px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.lightNightBlue};
`

export const BadgeWrapper = styled(Flex)<{ secondary?: boolean }>`
  position: absolute;
  top: -10px;
  right: -10px;
  width: 32px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`
